<template>
  <div class="menu-list">
    <ul>
      <li class="">
        <ul class="user-actions" :class="isOpened ? 'collapse in user-actions-open': 'user-actions-close'">
          <li>
            <a href="#/change_password" :class="{active: $route.name === 'ChangePassword'}"
               aria-expanded="false"><span class="icon is-small">
        <i class="fa fa-unlock-alt"></i></span>
              Change password
            </a>
          </li>
          <li>
            <a @click="$emit('logout')" aria-expanded="false"><span class="icon is-small">
        <i class="fa fa-sign-out"></i></span>
              Logout
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: ["isOpened"]
  }
</script>

<style scoped lang="scss">
</style>
